import React, { useState, useEffect } from 'react';
import { useScrollPosition } from '../../../shared/hooks/useScrollPosition';
import { ScrollToTopProps } from '../types';
import ScrollToTopPresentation from './ScrollToTopPresentation';

/**
 * Container component for ScrollToTop, handles scroll position logic
 */
const ScrollToTopContainer: React.FC<ScrollToTopProps> = () => {
  const scrollPosition = useScrollPosition();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  
  // Update visibility based on scroll position
  useEffect(() => {
    const scrollThreshold = 500; // Show button after scrolling down 500px
    setIsVisible(scrollPosition > scrollThreshold);
  }, [scrollPosition]);
  
  // Handler for scrolling to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <ScrollToTopPresentation
      isVisible={isVisible}
      onClick={scrollToTop}
    />
  );
};

export default ScrollToTopContainer;